/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { InjectionToken } from '@angular/core'

export const RESTRICT_GLOBAL_UI_CHANGES = new InjectionToken<boolean>('restrictGlobalUIChanges', {
  providedIn: 'root',
  factory: () => false,
})
